<template>
  <div class="empty">
    <img src="../assets/img/noresult.png" alt="暂无">
    <div class="text"><slot></slot></div>
  </div>
</template>

<script>
export default {
  name: "empty"
}
</script>

<style scoped lang="less">
  .empty{
    width: 100%;
    padding: 220px 0;
    text-align: center;
    img{
      width: 100%;
    }
    .text{
      margin-top: 20px;
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/empty.vue